import { api } from "@/lib/api";

export const fetcher = (u) => api.get(u).then((r) => r.data);

export const fmtN = (n) =>
  (n ?? 0).toLocaleString("fr-FR", { minimumFractionDigits: 0, maximumFractionDigits: 2 });

export const todayISO = () => new Date().toISOString().slice(0, 10);

export async function downloadXlsx(url, filename) {
  const r = await api.get(url, { responseType: "blob" });
  const blobUrl = URL.createObjectURL(r.data);
  const a = document.createElement("a");
  a.href = blobUrl;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(blobUrl);
}
